import { Box } from '@mui/material';
import { CompanyRole } from '@types';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useGetServiceAgreementsForCompany } from 'ogp/hooks/queryHooks/service-agreements/use-get-service-agreements-for-company';
import { AuthenticatedElement } from 'ogp/components/common/authenticated-element';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header, LwButton, Page, Toolbox } from 'redesign';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { PolicyGroups } from 'shared/utils/policy-controller';
import { routes } from 'Routes';
import { ServiceAgreementList } from './components/service-agreement-list/service-agreement-list';

export const ClientManagementDataProvider = () => {
  const serviceAgreementsQuery = useGetServiceAgreementsForCompany({ isLender: true });

  if (serviceAgreementsQuery.status !== 'success' || !serviceAgreementsQuery.data) {
    return <RenderUnsettledUI data={serviceAgreementsQuery} />;
  }

  const clients = serviceAgreementsQuery.data.filter(
    (agreement) => agreement.serviceAgreementPartyRole === 'LENDER'
  );

  return <ClientManagement data={clients} />;
};

const ClientManagement = ({ data }: { data: ServiceAgreementsResponse }) => {
  const { t } = useTranslation('ogp-screen-specific');
  const { allowClientManagement } = useFeatureFlagContext();
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();

  return (
    <Page
      header={
        <Header
          titleText={t('collegial-lending.customers.title', {
            defaultValue: 'Service account for Customers',
          })}
        />
      }
      toolbox={
        <Toolbox>
          {allowClientManagement ? (
            <AuthenticatedElement
              roles={[CompanyRole.ADMIN, CompanyRole.HQADMIN]}
              policyGroup={PolicyGroups.COMPANY}
            >
              <LwButton
                onClick={() => navigate(generatePath(routes.CollegialLendingCustomersCreate))}
              >
                {t('collegial-lending.customers.add-customer', { defaultValue: 'Klant toevoegen' })}
              </LwButton>
            </AuthenticatedElement>
          ) : null}
        </Toolbox>
      }
    >
      <Box width="100%">
        <ServiceAgreementList data={data} role="LENDER" />
      </Box>
    </Page>
  );
};
